var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcIllustrationThreeCvv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3125,
    y: 0.3125,
    width: 49.375,
    height: 31.375,
    rx: 2.6875,
    fill: "#D9D9D9",
    stroke: "#AEAEAE",
    strokeWidth: 0.625
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 50,
    height: 6.25,
    fill: "#858585"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 27,
    height: 6,
    rx: 1.25,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.625,
    y: 14.625,
    width: 10.75,
    height: 7.75,
    rx: 1.25,
    fill: "white",
    stroke: "#EE6666",
    strokeWidth: 1.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.25,
    cy: 18.5,
    r: 0.75,
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.625
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 18.5,
    r: 0.75,
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.625
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.75,
    cy: 18.5,
    r: 0.75,
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcIllustrationThreeCvv);
export default __webpack_public_path__ + "static/media/cc-illustration-threeCVV.39b650e4e68ab18f552d27a0a2b6aff7.svg";
export { ForwardRef as ReactComponent };